import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getUser, getUserRoles, updateUser, setErrors} from '../../../store/users/actions';
import { fetchMicrosoftUsers } from '../../../store/auth/actions';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import FormFieldInput from './FormFieldInput';

const UpdateUser = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { key } = useParams();
    const { roles, errors, userData, loading } = useSelector((state) => state.Users);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        // password: '',
        // isSsoAccount: false,
        isSsoAccount: true,
        role: ''
    });

    const rolesList = useMemo(
        () => roles.map(({ _id, title }) => ({ value: _id, label: title })),
        [roles]
    );

    useEffect(() => {
        dispatch(getUserRoles());
        dispatch(fetchMicrosoftUsers());
        dispatch(getUser({ key }));
        // dispatch(setErrors({ name: "", email: "", password: "", role: "" }));
        dispatch(setErrors({ name: "", email: "", role: "" }));
    }, [dispatch, key]);

    useEffect(() => {
        if (userData) {
            setFormData({
                name: userData?.name || '',
                email: userData?.email || '',
                // password: '',
                // isSsoAccount: userData?.azure_account || false,
                isSsoAccount: true,
                role: userData?.role?._id || ''
            });
        }
    }, [userData]);

    const validateField = useCallback((fieldName, value) => {
        switch (fieldName) {
            case 'name':
                return value.trim().length >= 2;
            case 'email':
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailPattern.test(value);
            // case 'password':
            //     if (formData.isSsoAccount) return true;
            //     return value.length >= 6;
            case 'role':
                return value !== '';
            default:
                return true;
        }
    }, []);    

    const handleInputChange = useCallback((field, value) => {
        if(field && value) {
            // if (field === 'isSsoAccount' && value === true) {
            //     dispatch(setErrors({ ...errors, password: '' }));
            // }

            setFormData((prev) => ({ ...prev, [field]: value }));

            const isValid = validateField(field, value);
            if (!isValid) {
                dispatch(setErrors({ ...errors, [field]: `Please enter a valid ${field}.` }));
            } else {
                dispatch(setErrors({ ...errors, [field]: '' }));
            }
        }
    }, [dispatch, errors, validateField]);

    const saveUser = useCallback(
        async (event) => {
            event.preventDefault();
            const newErrors = {};
    
            Object.keys(formData).forEach((field) => {
                // if (field === 'password' && formData.isSsoAccount) return;
                if (formData.isSsoAccount) return;
                if (!formData[field]) {
                    newErrors[field] = `Please enter your ${field}.`;
                }
            });
    
            // // Extra check for password length if it's provided
            // if (!formData.isSsoAccount && formData.password && formData.password.length < 6) {
            //     newErrors.password = 'Password must be at least 6 characters.';
            // }
    
            dispatch(setErrors(newErrors));
    
            if (Object.keys(newErrors).length === 0) {
                const dataToSubmit = { ...formData };
                // if (formData.isSsoAccount) {
                //     delete dataToSubmit.password;
                //     dataToSubmit.azure_account = true;
                // } else {
                //     dataToSubmit.azure_account = false;
                // }
    
                dispatch(updateUser({ formData: { ...dataToSubmit, id: userData?._id }, navigate }));
            }
        },
        [dispatch, formData, navigate, userData?._id]
    );
    

    if (loading || !userData) {
        return <p className="text-center mt-8 text-sm text-gray-500">Loading user details...</p>;
    }

    return (
        <>
            {/* <ModuleHeader className="text-2xl font-bold text-primary" title="Update User" /> */}
            {/* <p className="text-gray-600 text-sm mb-4">Update the user's information below.</p> */}
            <Card className="w-full mb-4">
                <CardHeader>Update User</CardHeader>
                <CardContent className="p-6">
                    <div className="flex flex-col gap-4 w-full">
                        <FormFieldInput
                            field="name"
                            fieldType="text"
                            value={formData.name}
                            handleInputChange={handleInputChange}
                            required={true}
                            error={errors.name}
                        />

                        {/* <FormFieldInput
                            field="isSsoAccount"
                            fieldType="checkbox"
                            label="SSO Account"
                            value={formData.isSsoAccount}
                            handleInputChange={handleInputChange}
                            required={true}
                            checkboxLabel="Is this an SSO Account?"
                        /> */}

                        <FormFieldInput
                            field="email"
                            fieldType="text"
                            value={formData.email}
                            handleInputChange={handleInputChange}
                            required={true}
                            error={errors.email}
                            disabled={true}
                        />

                        {/* {!formData.isSsoAccount && (
                            <FormFieldInput
                                field="password"
                                fieldType="password"
                                value={formData.password}
                                handleInputChange={handleInputChange}
                                required={false}
                                error={errors.password}
                            />
                        )} */}

                        <FormFieldInput
                            field="role"
                            fieldType="select"
                            label="Role"
                            options={rolesList}
                            value={formData.role}
                            handleInputChange={handleInputChange}
                            required={true}
                            error={errors.role}
                        />
                    </div>

                    <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4">
                        <Button variant="outline" className="w-full sm:w-auto" onClick={() => navigate("/users")}>
                            Back
                        </Button>
                        <Button className="w-full sm:w-auto" onClick={saveUser}>
                            Update User
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

export default UpdateUser;
